export const INITIALIZE_PASSWORD_RECOVERY = 'initialize-password-recovery';

const initializePasswordRecovery = () => (
  { type: INITIALIZE_PASSWORD_RECOVERY }
);
export default initializePasswordRecovery;
